import type { SearchConversationEnriched } from 'lib-search-types';
import { createContext, type ReactNode } from 'react';

import { ConversationsTableDensity } from 'components/conversation/conversationTable/conversationsTable.types';

export type ConversationRowContextValue = {
  readonly conversation: SearchConversationEnriched;
  /** Whether to show the filter menu item in the row menu. Defaults to true. */
  readonly showRowMenuFilter?: boolean;
  /** When provided, renders the row's action in place of the button that previews the conversation. */
  readonly renderAction?: (
    conversation: SearchConversationEnriched,
  ) => ReactNode;
  /** The table's density setting. */
  readonly density?: ConversationsTableDensity;
};

export const ConversationRowContext =
  createContext<ConversationRowContextValue>(undefined!);
